/*
 * House of Tones — scratch-card A/B arm (mobile browse only), lives inside the
 * v2 "Directe Kaart" shell (popup.js assigns 50/50 via .popup--scratch).
 * state 1 (scratch)  -> user scratches the gold cover off a <canvas>
 * state 2 (revealed) -> prize shows through, "Claim" button appears
 * state 3 (form)     -> the shared v2 heading/text/email form is revealed
 * State classes (scratch-revealed / scratch-form) live on the .popup ancestor.
 * The canvas only has a size once the popup is visible, so we (re)initialise
 * when the popup opens (watch .promo-popup for the is-active class) and tear
 * down (AbortController) when it closes.
 */
(function () {
  var REVEAL_AT = 0.45; // fraction scratched before auto-reveal

  // GA4 funnel event voor de kras-stap zelf. popup_view/popup_signup blijven eigendom
  // van popup.js (anders dubbeltelling); alleen popup_revealed hoort hier thuis.
  // Getagd met de variant die popup.js op de <promo-popup> zette (altijd 'ab_scratch'
  // in de praktijk, want deze stap bestaat alleen in die arm).
  function ga(name, popupEl) {
    if (typeof window.gtag !== 'function') return;
    var promo = popupEl && popupEl.closest('promo-popup');
    var variant = (promo && promo.dataset.variant) || 'ab_scratch';
    window.gtag('event', name, { popup: variant });
  }

  function initScratch(root) {
    if (!root || root.dataset.scratchReady === '1') return;
    var card = root.querySelector('[data-scratch-card]');
    var canvas = root.querySelector('[data-scratch-canvas]');
    var claim = root.querySelector('[data-scratch-claim]');
    if (!card || !canvas) return;

    var rect = card.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return; // not visible yet
    root.dataset.scratchReady = '1';

    var popup = root.closest('.popup') || root;
    var inner = root.closest('.promo-popup');
    var scratchLabel = (root.getAttribute('data-scratch-label') || 'Scratch here').toUpperCase();

    // reset any prior state (test-mode / theme-editor reopen)
    popup.classList.remove('scratch-revealed', 'scratch-form', 'popup-success');
    canvas.style.opacity = '';
    canvas.style.pointerEvents = '';
    canvas.style.transition = '';

    var ctx = canvas.getContext('2d');
    var ratio = Math.min(window.devicePixelRatio || 1, 2);

    var ac = new AbortController();
    var sig = { signal: ac.signal };
    var sigNP = { signal: ac.signal, passive: false };

    // small offscreen canvas for cheap "cleared fraction" checks (no full readback)
    var sample = document.createElement('canvas');
    sample.width = 40;
    sample.height = 25;
    var sctx = sample.getContext('2d', { willReadFrequently: true });

    function paint(w, h) {
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#e7d3ab');
      g.addColorStop(0.45, '#cdb583');
      g.addColorStop(0.55, '#d9c7a6');
      g.addColorStop(1, '#c2a878');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'soft-light';
      ctx.fillStyle = 'rgba(255,255,255,0.5)';
      ctx.fillRect(0, h * 0.18, w, h * 0.12);
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = 'rgba(86,64,30,0.62)';
      ctx.font = '600 ' + Math.round(Math.min(w, h) * 0.14) + 'px Helvetica, Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      try { ctx.letterSpacing = '3px'; } catch (e) {}
      ctx.fillText(scratchLabel, w / 2, h / 2);
    }

    function size() {
      // offsetWidth/Height ignore the popup-in scale() animation (getBoundingClientRect
      // would measure the mid-animation scaled size and leave the canvas too small).
      var w = card.offsetWidth, h = card.offsetHeight;
      if (w < 2) return;
      canvas.width = Math.round(w * ratio);
      canvas.height = Math.round(h * ratio);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      paint(w, h);
    }

    var drawing = false;
    var revealed = false;
    var lastCheck = 0;
    var last = null;

    function point(e) {
      var r = canvas.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    }

    function erase(p) {
      ctx.globalCompositeOperation = 'destination-out';
      // continuous thick stroke (connect points) so fast moves don't leave gaps
      if (last) {
        ctx.lineWidth = 46;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.beginPath();
        ctx.moveTo(last.x, last.y);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(p.x, p.y, 23, 0, Math.PI * 2);
      ctx.fill();
      last = p;
    }

    function clearedFraction() {
      sctx.clearRect(0, 0, sample.width, sample.height);
      sctx.drawImage(canvas, 0, 0, sample.width, sample.height);
      var d = sctx.getImageData(0, 0, sample.width, sample.height).data;
      var total = 0, clear = 0;
      for (var i = 3; i < d.length; i += 4) {
        total++;
        if (d[i] < 20) clear++;
      }
      return total ? clear / total : 0;
    }

    function maybeReveal(force) {
      if (revealed) return;
      var now = Date.now();
      if (!force && now - lastCheck < 150) return;
      lastCheck = now;
      if (clearedFraction() > REVEAL_AT) reveal();
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      popup.classList.add('scratch-revealed');
      ga('popup_revealed', popup);
      canvas.style.transition = 'opacity .45s ease';
      canvas.style.opacity = '0';
      canvas.style.pointerEvents = 'none';
    }

    function getEvtPoint(e) {
      var t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;
      return point(t);
    }

    function down(e) {
      drawing = true;
      last = null;
      if (e.cancelable) e.preventDefault();
      erase(getEvtPoint(e));
    }
    function move(e) {
      if (!drawing) return;
      if (e.cancelable) e.preventDefault();
      erase(getEvtPoint(e));
      maybeReveal(false);
    }
    function up() {
      if (drawing) { drawing = false; last = null; maybeReveal(true); }
    }

    // single event family (avoid pointer+touch double-draw on Safari)
    if ('PointerEvent' in window) {
      canvas.addEventListener('pointerdown', down, sigNP);
      canvas.addEventListener('pointermove', move, sigNP);
      window.addEventListener('pointerup', up, sig);
      window.addEventListener('pointercancel', up, sig);
    } else {
      canvas.addEventListener('touchstart', down, sigNP);
      canvas.addEventListener('touchmove', move, sigNP);
      window.addEventListener('touchend', up, sig);
      window.addEventListener('touchcancel', up, sig);
    }

    // keep the screen from moving while the popup is open (scratch, reveal and form).
    function blockMove(e) {
      // lock ALL touch-scroll while the popup is open: no scroll by design.
      // a focused email input is still scrolled into view natively by the browser,
      // so the form stays usable without manual scrolling.
      if (e.cancelable) e.preventDefault();
    }
    (root.closest('.popup__content-wrapper') || popup).addEventListener('touchmove', blockMove, sigNP);

    if (claim) {
      claim.addEventListener('click', function () {
        popup.classList.add('scratch-form');
        var email = popup.querySelector('.popup__newsletter input[type=email]');
        if (email) setTimeout(function () { email.focus(); }, 200);
      }, sig);
    }

    // teardown when the popup closes, so it re-inits cleanly next open
    if (inner) {
      var mo = new MutationObserver(function () {
        if (!inner.classList.contains('is-active')) {
          ac.abort();
          root.dataset.scratchReady = '';
          mo.disconnect();
        }
      });
      mo.observe(inner, { attributes: true, attributeFilter: ['class'] });
    }

    size();
    window.addEventListener('resize', function () { if (!revealed) size(); }, sig);
  }

  function boot() {
    document.querySelectorAll('[data-scratch]').forEach(initScratch);
  }

  // Shopify Inbox rewrites the inline style on #ShopifyChat, so hide its static
  // wrapper (#shopify-chat) instead while the popup is open; restore on close.
  function setChat(hidden) {
    [document.getElementById('shopify-chat'), document.getElementById('ShopifyChat')].forEach(function (c) {
      if (!c) return;
      if (hidden) {
        if (c.dataset.popupPrevDisplay === undefined) {
          c.dataset.popupPrevDisplay = c.style.getPropertyValue('display');
        }
        c.style.setProperty('display', 'none', 'important');
      } else if (c.dataset.popupPrevDisplay !== undefined) {
        var prev = c.dataset.popupPrevDisplay;
        if (prev) c.style.setProperty('display', prev);
        else c.style.removeProperty('display');
        delete c.dataset.popupPrevDisplay;
      } else {
        c.style.removeProperty('display');
      }
    });
  }

  function watch() {
    // Scope op de popup die de kras-DOM bevat -- niet blind de eerste .promo-popup
    // op de pagina, want de age-verifier-sectie deelt diezelfde class.
    var scratchRoot = document.querySelector('[data-scratch]');
    var inner = scratchRoot && scratchRoot.closest('.promo-popup');
    if (!inner) return;
    var wasActive = false;
    // Only react to a real closed->open / open->close transition. The popup also
    // mutates its class while active (show-image at +600ms, is-closing on close),
    // and we must not reset success/scratch state on those.
    function sync() {
      var active = inner.classList.contains('is-active');
      if (active === wasActive) return;
      wasActive = active;
      if (active) {
        setChat(true);
        var p = inner.querySelector('.popup'); // clear stale state on (re)open
        if (p) p.classList.remove('popup-success', 'scratch-revealed', 'scratch-form');
        setTimeout(boot, 50);
      } else {
        setChat(false);
      }
    }
    new MutationObserver(sync).observe(inner, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  if (document.readyState !== 'loading') watch();
  else document.addEventListener('DOMContentLoaded', watch);
})();
